import React from 'react';

const Page2 = ({
    secondPageRef,
    sending,
    styledInput,
    styledNotValid,
    image,
    imageValidity,
    handleImageUpload,
    image2,
    image2Validity,
    handleImage2Upload,
    image3,
    handleImage3Upload,
    anyTobaccoProductsValidity,
    useTobaccoLastTwoYearsValidity,
    handleAnyTobaccoProductsChange,
    handleUseTobaccoLastTwoYearsChange,
    handleGeneralQuestionsChange,
    generalQuestionsAnswers,
    generalQuestionsValidity,
    bankInfo,
    bankInfoValidity,
    handleBankInfoChange,
    spouseSignatureDate,
    applicantSignatureDate,
    handleApplicantSignatureDate,
    handlSpouseSignatureDateChange,
    routeNumberMinMaxValidity,
    displayedDateFormats,


    handleOpenModal1,
    handleOpenModal2,
    handleOpenModal3,

    healthQuestionsValidity,
    healthQuestions,
    handleForm2Change,
}) => {


    const generalQuestions = [
        {
            number: '1',
            question: 'Heart disorder, heart attack, stroke, rheumatic fever?',
            sub: {
                number: '11',
                question: 'Been a patient in any hospital, clinic, halfway house, or medical facility?'
            },
        },
        {
            number: '2',
            question: 'Diabetes, high blood sugar, pancreatitis?',
            sub: {
                number: '12',
                question: 'Used substances such as cocaine, heroin, marijuana, or anything not prescribed?'
            },
        },
        {
            number: '3',
            question: 'Internal cancer, tumor, cyst, leukemia?',
            sub: {
                number: '13',
                question: 'Been treated for drug or alcohol use?'
            },
        },
        {
            number: '4',
            question: "Alzheimer's disease, dementia, memory loss?",
            sub: {
                number: '14',
                question: 'Been advised to have tests, treatment, surgery or hospitization?'
            },
        },
        {
            number: '5',
            question: 'Sleep Apnea, cystic fibrosis?',
            sub: {
                number: '15',
                question: 'Been diagnosed or treated for AIDS?'
            },
        },
        {
            number: '6',
            question: 'Dizziness, anxiety, depression?',
            sub: {
                number: '16',
                question: 'Had a miscarriage or Caesarean Section?'
            },
        },
        {
            number: '7',
            question: "Arthritis (e.g. Osteoarthritis (OA), Rheumatoid Arthritis (RA), Psoriatic Arthritis (PsA), Fibromyalgia and Gout), Rheumatism?",
            sub: {
                number: '17',
                question: 'Any dependent (spouse or child(ren) under the age of 25), currently pregnant?'
            },
        },
        {
            number: '8',
            question: 'Asthma, emphysema, shortness of breath, or require the use of oxygen equipment?',
            sub: {
                number: '18',
                question: 'Been convicted of or pled guilty to a felony?'
            },
        },
        {
            number: '9',
            question: 'Disease or disorder of the eyes, ears, nose, or throat?',
            sub: {
                number: '19',
                question: 'Are you currently taking any medical prescriptions?'
            },
        },
        {
            number: '10',
            question: 'Do you expect, within the next 2 years, to change your country of residence or to travel outside of the United States, Canada, Caribbean Islands (excluding Haiti), Western Europe, Hong Kong, Australia or New Zealand?',
            sub: {
                number: '20',
                question: 'Within the past 2 years, have you: a) Flown, or do you intend within the next 2 years to fly, in an aircraft as a student pilot or licensed pilot?b) Engaged, or do you intend within the next 2 years to engage, in motor vehicle or boat racing, mountain or rock climbing, scuba diving, skydiving, ballooning, hang gliding or ultra light flying.'
            },
        },
    ]


    const reqBadge = "bg-red-600 text-white text-[8px] font-bold px-1 py-[0.5px] rounded shadow z-20 whitespace-nowrap pointer-events-none";

    return (
        <>
            <div ref={secondPageRef} className='w-[816px] min-h-[1104px] pb-8 border border-gray-300 bg-white text-[9.2px] font-pdf p-[24px] shadow-xl relative'>
                <div className='border-[4px] h-auto w-full border-[#305496] relative'>




                    {/* 1st row */}
                    <table className='w-full border-b border-[#305496]'>
                        <thead className='bg-indigo-300'>
                            <tr>
                                <th className='font-bold pt-1 border-r border-b border-[#305496]'>Has anyone being insured currently use or have used</th>
                                <th className='font-bold pt-1 border-r border-b border-[#305496]'>Primary</th>
                                <th className='font-bold pt-1 border-r border-b border-[#305496]'>Spouse</th>
                                <th className='font-bold pt-1 border-r border-b border-[#305496]'>Dependants</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='border-b border-[#305496]'>
                                <td className='border-r border-[#305496]'>Any Tobacco Products?</td>
                                <td className='border-r border-[#305496]'>
                                    <div className='flex space-x-2 py-1 pl-2 relative group' data-invalid={!anyTobaccoProductsValidity} style={(anyTobaccoProductsValidity || sending) ? {} : styledNotValid}>
                                        <span className={`absolute -top-[3px] right-1 text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>
                                        {!anyTobaccoProductsValidity && !sending && (
                                            <div className={`absolute -top-3 right-1 ${reqBadge}`}>Required</div>
                                        )}
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleAnyTobaccoProductsChange} value='Yes' name='anyTobaccoPrimary' /> Yes</div>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleAnyTobaccoProductsChange} value='No' name='anyTobaccoPrimary' /> No</div>
                                    </div>
                                </td>
                                <td className='border-r border-[#305496]'>
                                    <div className='flex space-x-2 py-1 pl-2'>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleAnyTobaccoProductsChange} value='Yes' name='anyTobaccoSpouse' /> Yes</div>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleAnyTobaccoProductsChange} value='No' name='anyTobaccoSpouse' /> No</div>
                                    </div>
                                </td>
                                <td className='border-r border-[#305496]'>
                                    <div className='flex space-x-2 py-1 pl-2'>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleAnyTobaccoProductsChange} value='Yes' name='anyTobaccoDependants' /> Yes</div>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleAnyTobaccoProductsChange} value='No' name='anyTobaccoDependants' /> No</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className='border-r border-[#305496]'>Used Tobacco within the last 24 months?</td>
                                <td className='border-r border-[#305496]'>
                                    <div className='flex space-x-2 py-1 pl-2 relative group' data-invalid={!useTobaccoLastTwoYearsValidity} style={(useTobaccoLastTwoYearsValidity || sending) ? {} : styledNotValid}>
                                        <span className={`absolute -top-[3px] right-1 text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>
                                        {!useTobaccoLastTwoYearsValidity && !sending && (
                                            <div className={`absolute -top-3 right-1 ${reqBadge}`}>Required</div>
                                        )}
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleUseTobaccoLastTwoYearsChange} value='Yes' name='usedTobaccoPrimary' /> Yes</div>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleUseTobaccoLastTwoYearsChange} value='No' name='usedTobaccoPrimary' /> No</div>
                                    </div>
                                </td>
                                <td className='border-r border-[#305496]'>
                                    <div className='flex space-x-2 py-1 pl-2'>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleUseTobaccoLastTwoYearsChange} value='Yes' name='usedTobaccoSpouse' /> Yes</div>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleUseTobaccoLastTwoYearsChange} value='No' name='usedTobaccoSpouse' /> No</div>
                                    </div>
                                </td>
                                <td className='border-r border-[#305496]'>
                                    <div className='flex space-x-2 py-1 pl-2'>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleUseTobaccoLastTwoYearsChange} value='Yes' name='usedTobaccoDependants' /> Yes</div>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleUseTobaccoLastTwoYearsChange} value='No' name='usedTobaccoDependants' /> No</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>


                    {/* 2nd row */}
                    <div className='grid'>
                        <div className='grid border-b border-t-[3px] border-[#305496] bg-indigo-300 font-bold text-center'>
                            GENERAL & HEALTH QUESTIONS
                        </div>

                        <div className='grid border-b border-[#305496] font-bold'>
                            During the past 5 years, have you or anyone being insured been diagnosed with or have:
                        </div>


                        {
                            generalQuestions.map((question, index) => (
                                <div className='grid grid-cols-20 border-b border-[#305496]' key={index}>
                                    <div className={`flex space-x-2 col-span-8 border-r border-[#305496] pr-1 relative ${!generalQuestionsValidity['question' + (index + 1)] && !sending ? 'bg-red-50 text-red-900 font-semibold' : ''}`}>
                                        <span className={`absolute right-1 text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>
                                        <div>{index + 1}</div>
                                        <div>{question.question}</div>
                                    </div>
                                    <div className='flex space-x-2 col-span-2 py-1 justify-center border-r border-[#305496] relative group' data-invalid={!generalQuestionsValidity['question' + (index + 1)]} style={(generalQuestionsValidity['question' + (index + 1)] || sending) ? {} : styledNotValid}>
                                        {!generalQuestionsValidity['question' + (index + 1)] && !sending && (
                                            <div className={`absolute -top-2.5 right-0.5 ${reqBadge}`}>Required</div>
                                        )}
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleGeneralQuestionsChange} value='Yes' name={`question${index + 1}`} /> Yes</div>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleGeneralQuestionsChange} value='No' name={`question${index + 1}`} /> No</div>
                                    </div>
                                    <div className={`flex space-x-2 col-span-8 border-r border-[#305496] pr-1 relative ${!generalQuestionsValidity['question' + (index + 11)] && !sending ? 'bg-red-50 text-red-900 font-semibold' : ''}`}>
                                        <div>{index + 11}</div>
                                        <div>{question.sub.question}</div>
                                        <span className={`absolute right-1 text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span>
                                    </div>
                                    <div className='flex space-x-2 col-span-2 py-1 justify-center relative group' data-invalid={!generalQuestionsValidity['question' + (index + 11)]} style={(generalQuestionsValidity['question' + (index + 11)] || sending) ? {} : styledNotValid}>
                                        {!generalQuestionsValidity['question' + (index + 11)] && !sending && (
                                            <div className={`absolute -top-2.5 right-0.5 ${reqBadge}`}>Required</div>
                                        )}
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleGeneralQuestionsChange} value='Yes' name={`question${index + 11}`} /> Yes</div>
                                        <div className='flex items-center text-[9px] h-[10px]'><input required type='radio' className='w-[9px] h-[9px] mr-[3px]' onChange={handleGeneralQuestionsChange} value='No' name={`question${index + 11}`} /> No</div>
                                    </div>
                                </div>
                            ))
                        }


                    </div>


                    {/* 3rd row */}
                    <div className={`grid border-b border-t-[3px] border-[#305496] font-bold relative ${healthQuestionsValidity.some(r => Object.values(r).some(v => !v)) && !sending ? 'bg-red-100 text-red-900' : 'bg-indigo-300'}`}>
                        <span>
                            If you answered YES to any of the above questions, please provide details below for every proposed insured:
                        </span>
                        {healthQuestionsValidity.some(r => Object.values(r).some(v => !v)) && !sending && (
                            <div className={`absolute -top-2.5 right-1 ${reqBadge}`}>Required</div>
                        )}
                    </div>


                    {/* 4th row */}
                    <table className='w-full'>
                        <thead>
                            <tr>
                                <th className='border border-[#305496] bg-indigo-100 py-1'>Name</th>
                                <th className='border border-[#305496] bg-indigo-100 py-1'>Medical Condition</th>
                                <th className='border border-[#305496] bg-indigo-100 py-1'>Prescription Medication Name</th>
                                <th className='border border-[#305496] bg-indigo-100 py-1'>Dosage</th>
                                <th className='border border-[#305496] bg-indigo-100 py-1'>Frequency</th>
                                <th className='border border-[#305496] bg-indigo-100 py-1'>Date of Onset</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                healthQuestions.map((_, index) => (
                                    <tr key={index} className='min-h-[28px]'>
                                        <td className='border border-[#305496] py-1 pl-1 relative'>
                                            {!healthQuestionsValidity[index].fullName && !sending && (
                                                <div className={`absolute -top-3.5 left-1 ${reqBadge}`}>Required</div>
                                            )}
                                            <div className='flex justify-center w-full px-1'>
                                                {
                                                    sending ?
                                                        <span className='break-words leading-tight text-[9px]'>{healthQuestions[index].fullName}</span> :
                                                        <input
                                                            type='text'
                                                            name='fullName'
                                                            data-invalid={!healthQuestionsValidity[index].fullName}
                                                            style={healthQuestionsValidity[index].fullName ? styledInput : styledNotValid}
                                                            value={healthQuestions[index].fullName}
                                                            onChange={(e) => handleForm2Change(e, index)}
                                                            className='w-full'
                                                        />
                                                }
                                            </div>

                                        </td>
                                        <td className='border border-[#305496] py-1 pl-1 relative'>
                                            {!healthQuestionsValidity[index].medicalCondition && !sending && (
                                                <div className={`absolute -top-3.5 left-1 ${reqBadge}`}>Required</div>
                                            )}
                                            <div className='flex justify-center w-full px-1'>
                                                {
                                                    sending ?
                                                        <span className='break-words leading-tight text-[9px]'>{healthQuestions[index].medicalCondition}</span> :
                                                        <input
                                                            type='text'
                                                            name='medicalCondition'
                                                            data-invalid={!healthQuestionsValidity[index].medicalCondition}
                                                            style={healthQuestionsValidity[index].medicalCondition ? styledInput : styledNotValid}
                                                            value={healthQuestions[index].medicalCondition}
                                                            onChange={(e) => handleForm2Change(e, index)}
                                                            className='w-full'
                                                        />
                                                }
                                            </div>
                                        </td>
                                        <td className='border border-[#305496] py-1 pl-1 relative'>
                                            {!healthQuestionsValidity[index].prescriptionMedication && !sending && (
                                                <div className={`absolute -top-3.5 left-1 ${reqBadge}`}>Required</div>
                                            )}
                                            <div className='flex justify-center w-full px-1'>
                                                {
                                                    sending ?
                                                        <span className='break-words leading-tight text-[9px]'>{healthQuestions[index].prescriptionMedication}</span> :
                                                        <input
                                                            type='text'
                                                            name='prescriptionMedication'
                                                            data-invalid={!healthQuestionsValidity[index].prescriptionMedication}
                                                            style={healthQuestionsValidity[index].prescriptionMedication ? styledInput : styledNotValid}
                                                            value={healthQuestions[index].prescriptionMedication}
                                                            onChange={(e) => handleForm2Change(e, index)}
                                                            className='w-full'
                                                        />
                                                }
                                            </div>
                                        </td>
                                        <td className='border border-[#305496] py-1 pl-1 relative'>
                                            {!healthQuestionsValidity[index].dosage && !sending && (
                                                <div className={`absolute -top-3.5 left-1 ${reqBadge}`}>Required</div>
                                            )}
                                            <div className='flex justify-center w-full px-1'>
                                                {
                                                    sending ?
                                                        <span className='break-words leading-tight text-[9px]'>{healthQuestions[index].dosage}</span> :
                                                        <input
                                                            type='text'
                                                            name='dosage'
                                                            data-invalid={!healthQuestionsValidity[index].dosage}
                                                            style={healthQuestionsValidity[index].dosage ? styledInput : styledNotValid}
                                                            value={healthQuestions[index].dosage}
                                                            onChange={(e) => handleForm2Change(e, index)}
                                                            className='w-full'
                                                        />
                                                }
                                            </div>
                                        </td>
                                        <td className='border border-[#305496] py-1 pl-1 relative'>
                                            {!healthQuestionsValidity[index].frequency && !sending && (
                                                <div className={`absolute -top-3.5 left-1 ${reqBadge}`}>Required</div>
                                            )}
                                            <div className='flex justify-center w-full px-1'>
                                                {
                                                    sending ?
                                                        <span className='break-words leading-tight text-[9px]'>{healthQuestions[index].frequency}</span> :
                                                        <input
                                                            type='text'
                                                            name='frequency'
                                                            data-invalid={!healthQuestionsValidity[index].frequency}
                                                            style={healthQuestionsValidity[index].frequency ? styledInput : styledNotValid}
                                                            value={healthQuestions[index].frequency}
                                                            onChange={(e) => handleForm2Change(e, index)}
                                                            className='w-full'
                                                        />
                                                }
                                            </div>
                                        </td>
                                        <td className='border border-[#305496] py-1 pl-1 relative'>
                                            {!healthQuestionsValidity[index].dateOfOnset && !sending && (
                                                <div className={`absolute -top-3.5 left-1 ${reqBadge}`}>Required</div>
                                            )}
                                            <div className='flex justify-center w-full px-1'>
                                                {
                                                    sending ?
                                                        <span className='break-words leading-tight text-[9px]'>{displayedDateFormats.healthQuestions[index].dateOfOnset}</span> :
                                                        <input
                                                            type='date'
                                                            name='dateOfOnset'
                                                            data-invalid={!healthQuestionsValidity[index].dateOfOnset}
                                                            style={healthQuestionsValidity[index].dateOfOnset ? styledInput : styledNotValid}
                                                            value={healthQuestions[index].dateOfOnset}
                                                            onChange={(e) => handleForm2Change(e, index)}
                                                            className='w-full'
                                                        />
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>


                    {/* New Row */}
                    <div className='grid grid-cols-2 relative'>
                        <div className='grid'>
                            <div className='grid border-b border-t-[3px] border-[#305496] bg-indigo-300 font-bold text-center'>
                                <div>PAYMENT INFORMATION</div>
                                <div>AUTHORIZATION FOR AUTOMATIC BANK DRAFT</div>
                            </div>
                            <div className='border-b border-[#305496] flex'>
                                <div className='border-r border-[#305496] w-[130px] py-4 pl-1'>Bank / Financial Institution: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                                <div className='grow py-1 pl-1 text-sm relative'>
                                    <div className='flex justify-center w-full px-1'>
                                        {
                                            sending ?
                                                <span className='break-words leading-tight text-[11px]'>{bankInfo.bankInstitution}</span> :
                                                <div className='relative group w-full'>
                                                    {!bankInfoValidity.bankInstitution && (
                                                        <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                                                    )}
                                                    <input required
                                                        type='text'
                                                        name='bankInstitution'
                                                        data-invalid={!bankInfoValidity.bankInstitution}
                                                        style={bankInfoValidity.bankInstitution ? styledInput : styledNotValid}
                                                        value={bankInfo.bankInstitution}
                                                        onChange={handleBankInfoChange}
                                                        className='w-full'
                                                    />
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='border-b border-[#305496] flex'>
                                <div className='border-r border-[#305496] w-[130px] py-4 pl-1'>Routing Number: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                                <div className='grow py-1 pl-1 text-sm'>
                                    <div className='flex justify-center w-full px-1'>
                                        {
                                            sending ?
                                                bankInfo.routingNumber :
                                                <div className='relative group w-full'>
                                                    <div className={`absolute ${(!routeNumberMinMaxValidity || !bankInfoValidity.routingNumber) && !sending ? 'block' : 'hidden'} bg-red-600 -top-3.5 left-0 text-white text-[8px] font-bold py-[0.5px] px-1 text-center rounded shadow z-20 whitespace-nowrap pointer-events-none`}>
                                                        {!routeNumberMinMaxValidity ? 'Invalid Routing Number (9 digits)' : 'Required'}
                                                    </div>
                                                    <input required
                                                        type='text'
                                                        inputMode='numeric'
                                                        name='routingNumber'
                                                        data-invalid={!bankInfoValidity.routingNumber || !routeNumberMinMaxValidity}
                                                        style={
                                                            bankInfoValidity.routingNumber ?
                                                                routeNumberMinMaxValidity ? styledInput
                                                                    : styledNotValid
                                                                : styledNotValid
                                                        }
                                                        value={bankInfo.routingNumber}
                                                        onChange={handleBankInfoChange}
                                                        className='w-full'
                                                    />
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='border-b border-[#305496] flex'>
                                <div className='border-r border-[#305496] w-[130px] py-4 pl-1'>Account Number: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                                <div className='grow py-1 pl-1 text-sm'>
                                    <div className='flex justify-center w-full px-1'>
                                        {
                                            sending ?
                                                bankInfo.accountNumber :
                                                <div className='relative group w-full'>
                                                    {!bankInfoValidity.accountNumber && (
                                                        <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                                                    )}
                                                    <input required
                                                        type='text'
                                                        name='accountNumber'
                                                        data-invalid={!bankInfoValidity.accountNumber}
                                                        style={bankInfoValidity.accountNumber ? styledInput : styledNotValid}
                                                        value={bankInfo.accountNumber}
                                                        onChange={handleBankInfoChange}
                                                        className='w-full'
                                                    />
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='border-b border-[#305496] flex'>
                                <div className='border-r border-[#305496] w-[130px] py-4 pl-1'>Account Holder Name(s): <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                                <div className='grow py-1 pl-1 text-sm'>
                                    <div className='flex justify-center w-full px-1'>
                                        {
                                            sending ?
                                                <span className='break-words leading-tight text-[11px]'>{bankInfo.accountHolderName}</span> :
                                                <div className='relative group w-full'>
                                                    {!bankInfoValidity.accountHolderName && (
                                                        <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                                                    )}
                                                    <input required
                                                        type='text'
                                                        name='accountHolderName'
                                                        data-invalid={!bankInfoValidity.accountHolderName}
                                                        style={bankInfoValidity.accountHolderName ? styledInput : styledNotValid}
                                                        value={bankInfo.accountHolderName}
                                                        onChange={handleBankInfoChange}
                                                        className='w-full'
                                                    />
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='border-b border-[#305496] flex'>
                                <div className='border-r border-[#305496] w-[130px] py-4 pl-1'>E-Signature of Account Holder(s): <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>

                                <input required
                                    type="file"

                                    accept="image/*"
                                    id="fileInput"
                                    style={{ display: 'none', }}
                                    onChange={handleImageUpload}
                                />
                                <div className='relative group'>
                                    <button
                                        type="button"
                                        onClick={handleOpenModal1}
                                        data-invalid={!imageValidity}
                                        style={{
                                            padding: '4px',
                                            width: '180px',
                                            height: '80px',
                                            ...(imageValidity || sending) ? styledInput : styledNotValid,
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <div style={{
                                            backgroundImage: image ? `url(${image})` : 'none',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'center',
                                            width: '100%',
                                            height: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}>
                                            {!image && !imageValidity && !sending && (
                                                <span className="text-red-600 font-semibold text-[10px]">Signature Required (Click to Sign)</span>
                                            )}
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className='border-l-[3px] border-b border-[#305496]'>
                            <div className='grid border-b border-t-[3px] border-[#305496] bg-indigo-300 font-bold text-center'>
                                <div className='text-lg'>DISCLAIMER AND SIGNATURE</div>
                                <div>Please ensure this form is filled out completely. I certify that my answers are true and complete to
                                    the best of my knowledge. I also understand that there is a one-time enrollment fee of $6 to $50
                                    for my health plan and $25 for my dental plan.
                                </div>
                                <div>I acknowledge that my application will be subject to underwriting for approval and that my e-signature
                                    will be used for the entirety of the enrollment process to insurance
                                    carriers available in my state and for what I am pre-approved for.
                                    My personal and payment information is securely submitted through a secure portal.
                                </div>
                            </div>
                            <div className='grid h-[230px] border'>
                                <div className='grid grid-cols-2 border-b border-[#305496]'>
                                    <div className='border-r border-[#305496]'>
                                        <div className='pl-1'>Applicant E-Signature: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                                        <input required
                                            type="file"
                                            accept="image/*"
                                            id="fileInput2"
                                            style={{ display: 'none' }}
                                            onChange={handleImage2Upload}
                                        />
                                        <div className='relative group'>
                                            <button
                                                type="button"
                                                onClick={handleOpenModal2}
                                                data-invalid={!image2Validity}
                                                style={{
                                                    padding: '4px',
                                                    width: '180px',
                                                    height: '80px',
                                                    ...(image2Validity || sending) ? styledInput : styledNotValid,
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <div style={{
                                                    backgroundImage: image2 ? `url(${image2})` : 'none',
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundSize: 'contain',
                                                    backgroundPosition: 'center',
                                                    width: '100%',
                                                    height: '100%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}>
                                                    {!image2 && !image2Validity && !sending && (
                                                        <span className="text-red-600 font-semibold text-[10px]">Signature Required (Click to Sign)</span>
                                                    )}
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='pl-1'>Date: <span className={`text-sm text-error  ${sending ? 'hidden' : ''}`}>*</span></div>
                                        <div className='flex flex-col items-center justify-center text-sm'>
                                            <div className='flex justify-center w-full px-1'>
                                                {
                                                    sending ?
                                                        displayedDateFormats.applicantSignatureDate :
                                                        <div className='relative group w-full'>
                                                            {!applicantSignatureDate.validity && (
                                                                <div className={`absolute -top-3.5 left-0 ${reqBadge}`}>Required</div>
                                                            )}
                                                            <input required
                                                                type='date'
                                                                name='applicantDate'
                                                                data-invalid={!applicantSignatureDate.validity}
                                                                style={applicantSignatureDate.validity ? styledInput : styledNotValid}
                                                                value={applicantSignatureDate.date}
                                                                onChange={handleApplicantSignatureDate}
                                                                className='w-full'
                                                            />
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='grid grid-cols-2'>
                                    <div className='border-r border-[#305496]'>
                                        <div className='pl-1'>Spouse E-Signature:</div>
                                        <input required
                                            type="file"
                                            accept="image/*"
                                            id="fileInput3"
                                            style={{ display: 'none' }}
                                            onChange={handleImage3Upload}
                                        />
                                        <button
                                            onClick={handleOpenModal3}
                                            style={{
                                                padding: '4px',
                                                width: '180px',
                                                height: '80px',
                                                ...styledInput,
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <div style={{
                                                backgroundImage: image3 ? `url(${image3})` : 'none',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundSize: 'contain',
                                                backgroundPosition: 'center',
                                                width: '100%',
                                                height: '100%'
                                            }} />
                                        </button>
                                    </div>
                                    <div>
                                        <div className='pl-1'>Date:</div>
                                        <div className='flex flex-col items-center justify-center text-sm'>
                                            <div className='flex justify-center w-full px-1'>
                                                {
                                                    sending ?
                                                        displayedDateFormats.spouseSignatureDate :
                                                        <input required
                                                            type='date'
                                                            name='spouseDate'
                                                            style={styledInput}
                                                            value={spouseSignatureDate}
                                                            onChange={handlSpouseSignatureDateChange}
                                                            className='w-full'
                                                        />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>



                {/* Footer */}
                <div className='absolute w-full bottom-7 flex justify-between text-[9px] mt-4 px-16'>
                    <div className='text-error'><span className='text-sm'>*</span> Required Field</div>
                    <div>Page 2 of 2</div>
                </div>
            </div >
        </>
    );
}

export default Page2;
